import styled from 'styled-components'

import {
  Text,
  Colors,
  Spacing,
  StackChildren,
} from '@doordash/design-language'

export const CityJobsContainer = styled(StackChildren)`
  width: 180px;
`

export const CityTitle = styled(Text)`
  min-height: ${Spacing.XLarge}px;
`

export const Job = styled(Text)`
  text-decoration: none;
  color: ${Colors.SystemGrey60} !important;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
